import { render, staticRenderFns } from "./TokenRole.vue?vue&type=template&id=46af9522&scoped=true"
import script from "./TokenRole.vue?vue&type=script&lang=js"
export * from "./TokenRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af9522",
  null
  
)

export default component.exports